import { CheckboxField } from '@calendly/ui/form/checkbox-field';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const actionContainerIsPhoneCss = "aamulw9";
const actionContainerCss = "a1siczq4";
export const ActionContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(actionContainerCss, {
    [actionContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const daysContainerCss = "dh99jez";
export const DaysContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(daysContainerCss, props.className)} />;
});
const dayContainerIsTabletUpCss = "dkunjq6";
const dayContainerCss = "d1v9orpm";
export const DayContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(dayContainerCss, {
    [dayContainerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const dayIconCss = "d1yh7f8a";
export const DayIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dayIconCss, props.className)} />;
});
const checkboxIsTabletUpCss = "c1d0sv6v";
const checkboxCss = "ctnm2xb";
export const Checkbox = forwardRef((props, ref) => {
  const isTabletUp = useDeviceType('isTabletUp');
  return <CheckboxField ref={ref} {...props} className={classNames(checkboxCss, {
    [checkboxIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});

// Export CSS classes for external usage
export { actionContainerCss, daysContainerCss, dayContainerCss, dayIconCss, checkboxCss };

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");